"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
//
// assets
//
const noCustomers_webp_1 = __importDefault(require("../../../assets/images/dashboard/noCustomers.webp"));
const queryDefinitions_1 = require("../../../queryDefinitions");
const customersCopy_1 = require("../../../copy/customersCopy");
const tokenHeader_1 = require("../../../tokenHeader");
//
// components
//
const DataTable_1 = __importDefault(require("../Tables/DataTable"));
const CustomerModal_1 = __importDefault(require("../Modals/CustomerModal"));
//
// hooks
//
const useInfiniteScroll_1 = require("../../../hooks/useInfiniteScroll");
const usePaginatedSearch_1 = __importDefault(require("../../usePaginatedSearch"));
const useAccountChange_1 = __importDefault(require("../../useAccountChange"));
//
// styles
//
const StyledHeader_1 = require("../StyledHeader");
const StyledMainContainer_1 = require("../StyledMainContainer");
const pageCount = 12;
const Customers = () => {
    var _a, _b;
    const [detailedCustomer, setDetailedCustomer] = react_1.default.useState({});
    const [showModal, setShowModal] = react_1.default.useState(false);
    const [getFirstPageCustomers, 
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'loading' does not exist on type '((optio... Remove this comment to see the full error message
    { loading, data, fetchMore, renderWithLoadingAndErrorHandling }] = (0, tokenHeader_1.useAuthedLazyQuery)(queryDefinitions_1.GET_CUSTOMERS);
    const { searched, handleSearch, handleLoadNext } = (0, usePaginatedSearch_1.default)(fetchMore, 'customers', data);
    (0, useInfiniteScroll_1.useInfiniteScroll)({
        hasNext: ((_b = (_a = data === null || data === void 0 ? void 0 : data.customers) === null || _a === void 0 ? void 0 : _a.pageInfo) === null || _b === void 0 ? void 0 : _b.hasNextPage) || false,
        loadNext: handleLoadNext
    });
    (0, useAccountChange_1.default)(() => {
        // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
        getFirstPageCustomers({ variables: { first: pageCount } });
    });
    const handleToggleModal = (0, react_1.useCallback)(() => {
        setShowModal((current) => !current);
    }, [setShowModal]);
    function handlePressButton(customer) {
        setDetailedCustomer(customer.node);
        handleToggleModal();
    }
    function renderCustomers() {
        return (react_1.default.createElement(StyledMainContainer_1.StyledMainContainer, { className: 'customers' },
            showModal && (react_1.default.createElement(CustomerModal_1.default, { customer: detailedCustomer, display: showModal, handleToggleModal: handleToggleModal })),
            react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header', role: 'heading' }, customersCopy_1.customersCopy.mainHeader),
            react_1.default.createElement(DataTable_1.default, { button: customersCopy_1.customersCopy.button, data: data.customers.edges, dataType: 'customer', headers: [
                    customersCopy_1.customersCopy.column1,
                    customersCopy_1.customersCopy.column2,
                    customersCopy_1.customersCopy.column3
                ], loading: loading, onPressButton: handlePressButton, onSearch: handleSearch })));
    }
    return renderWithLoadingAndErrorHandling({
        copy: {
            noRecordsHeader: customersCopy_1.customersCopy.noCustomersHeader,
            noRecordsParagraph: customersCopy_1.customersCopy.noCustomersParagraph,
            noRecordsImage: noCustomers_webp_1.default
        },
        key: 'customers',
        searched,
        success: renderCustomers
    });
};
exports.default = Customers;
